import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/css/public.css'
import $ from 'jquery'
import "popper.js/dist/popper.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import 'vant/lib/index.css';
import { Collapse, CollapseItem, Popup, Button, Overlay,Toast } from 'vant';
import interfaceAPI from '@/assets/js/request/interface';
import VueClipboard from 'vue-clipboard2'
import func from '@/assets/js/common/func';
import VueI18n from 'vue-i18n';
import GLOBAL from './components/Global';

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Overlay);
Vue.use(func);
Vue.use(VueI18n);
Vue.use(VueClipboard);

Vue.prototype.$interfaceAPI = interfaceAPI;
Vue.prototype.$Toast = Toast;
Vue.prototype.$ = $;
Vue.prototype.GLOBAL = GLOBAL;


const i18n = new VueI18n({
  locale: Boolean(localStorage.getItem('languageType')) ? localStorage.getItem('languageType') : 'en',    // 语言标识
  messages: {
    'cn': require('@/assets/lang/cn'),   // 中文语言包
    'en': require('@/assets/lang/en'),    // 英文语言包
    'jp': require('@/assets/lang/jp'),    // 日本语言包
    'ke': require('@/assets/lang/ke'),    // 韩国语言包
  }
})

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js